import React from "react"
import Account from "../layouts/Account"
import "../styles/global.css"
import "../styles/canfone.css"
export default function AccountPage() {
  return <Account lang="fr"/>
}